import { Pipe } from '@angular/core';
import { DocumentReference } from '@angular/fire/firestore';
import { ImageResolutionValue } from '../../../libs/models/media/image-resolution.model';
import { ImageResource } from '../../../libs/models/media/image-resource.model';
import { DownloadURLPipe } from '../../storage/pipes/download-url.pipe';
import { getImageResolutionRef } from '../../../libs/firestore/refs/media.refs';
import { Observable, of, startWith } from 'rxjs';

const ASSET_BASE_PATH = 'assets/images/'; // TOOD move to path file

@Pipe({
  name: 'imageResolution',
})
export class ImageResolutionPipe extends DownloadURLPipe {
  override transform(
    imageResourceRef: DocumentReference<ImageResource> | undefined,
    resolution: ImageResolutionValue = '1280x1280',
    defaultImageType: 'solid' | 'symbol' | 'user' | null = null
  ): Observable<string | null> {
    const defaultImageFilePath = this.getDefaultImageFilePath(defaultImageType);
    if (!imageResourceRef) {
      return of(defaultImageFilePath);
    }
    const imageResolutionRef = getImageResolutionRef(imageResourceRef, resolution);
    return super.transform(imageResolutionRef).pipe(startWith(defaultImageFilePath));
  }

  private getDefaultImageFilePath(defaultImageType: 'solid' | 'symbol' | 'user' | null) {
    switch (defaultImageType) {
      case 'solid':
        return ASSET_BASE_PATH + 'image_placeholder_solid.webp';
      case 'symbol':
        return ASSET_BASE_PATH + 'image_placeholder_symbol.webp';
      case 'user':
        return ASSET_BASE_PATH + 'user_placeholder.png';
      default:
        return null;
    }
  }
}
